import {OverlayComponentDefaultBox} from "./overlay.component.default.box";

export const OverlayComponentBox = OverlayComponentDefaultBox;